import ComparisonTable from "@/components/comparisonTable";
import { TABLE_DATA } from "./constants";

const ComparisonComponent = () => {
  return <ComparisonTable {...TABLE_DATA} />;
};

export default ComparisonComponent;
